<template>
  <header class="wrapper">
    <h1>{{ article.title }}</h1>
    <grid v-if="article.Tags" horizontal="center" wrap="wrap">
      <template v-for="tag in article.Tags.slice(0, 5)">
        <grid-item>
          <router-link
            :to="{ name: SEARCH_PAGE_NAME, query: { tags: tag.id } }"
            class="link"
          >
            <h3 class="tag-wrapper">
              <i class="iconmoon-tag"></i> {{ tag.name }}
            </h3>
          </router-link>
        </grid-item>
      </template>
    </grid>
    <div class="separator"></div>
    <ul v-if="article.Author">
      <li>
        Posted By <span class="author">{{ article.Author.name }}</span>
      </li>
      <li>
        <time :datetime="article.published_at">{{
          parseDate(article.published_at)
        }}</time>
      </li>
    </ul>
    <div
      class="excerpt"
      v-if="article.show_excerpt && article.excerpt"
      v-html="article.excerpt"
    ></div>
  </header>
</template>

<script>
import {
  DEV_PROFILES_PAGE_NAME,
  SEARCH_PAGE_NAME
} from "../../../router/pageNameConstants";
import { parseDate } from "../../../lib/utils";

export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      DEV_PROFILES_PAGE_NAME,
      SEARCH_PAGE_NAME
    };
  },
  methods: {
    parseDate
  }
};
</script>

<style scoped lang="scss">
@import "./../../../assets/styles/vars";

$h-padding: 100px;
$v-padding: 40px;
$screen-big: 1270px;

.tag-wrapper {
  color: $mainRed;
  font-size: 1em;
  font-weight: normal;
  margin: 0;
}

.author {
  color: $mainRed;
}

.wrapper {
  padding: 0 100px 30px;
  text-align: center;

  @media (max-width: $screen-big) {
    padding-left: 0;
    padding-right: 0;
  }
}

.excerpt {
  margin-top: 50px;
  margin-bottom: 15px;
  padding: 30px 0;
  font-size: 18px;
  line-height: 34.8px;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
}

h1 {
  margin: 0 0 18px;
  font-family: $sarala;
  font-size: 52px;

  @media (max-width: $screen-xs-max) {
    font-size: 28px;
  }
}

h3 {
  margin: 0 0 35px;
  font-family: $metron;
  font-size: 21px;
}

.separator {
  width: 180px;
  height: 2px;
  margin: 35px auto;
  background: #771315;

  @media (max-width: $screen-xs) {
    margin: 20px auto;
  }
}

ul {
  margin: 0 0 1em;
  padding: 0;
  list-style-type: none;

  @media (max-width: $screen-xs-max) {
    margin-bottom: 25px;
  }

  time {
    font-size: 14px;
  }

  li {
    display: inline-block;
    font-family: $metron;
    font-size: 14px;
    letter-spacing: 0.1em;

    &:not(:last-child) {
      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 10px;
        margin: 0 10px 0 5px;
        line-height: 1;
        background-color: #fff;
      }
    }

    @media (max-width: $screen-xs-max) {
      display: block;

      &::after {
        display: none !important;
      }
    }
  }

  a {
    color: $mainRed;

    &:hover {
      color: darken($mainRed, 12%);
    }
  }
}

.introduction {
  margin: 0 0 40px;
  padding: 30px 80px 45px;
  font-family: $metron;
  font-size: 18px;
  line-height: 1.9;
  border-top: 1px solid #2c2c2c;
  border-bottom: 1px solid #2c2c2c;

  @media (max-width: $screen-big) {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: $screen-sm-max) {
    padding-top: 25px;
    padding-bottom: 25px;
    font-size: 14px;
  }
}
</style>
